type ServiceCapabilityGroup = {
  title: string;
  accentClass: 'accentRoutine' | 'accentDiagnostics' | 'accentComfort';
  items: { label: string; iconName: string }[];
};

const serviceCapabilityGroups: ServiceCapabilityGroup[] = [
  {
    title: 'Routine maintenance',
    accentClass: 'accentRoutine',
    items: [
      { label: 'Oil & Filter Change', iconName: 'Droplet' },
      { label: 'Tire Rotation & Balancing', iconName: 'Circle' },
      { label: 'Multi-Point Inspection', iconName: 'ClipboardCheck' },
      { label: 'State Inspection', iconName: 'Car' }
    ]
  },
  {
    title: 'Diagnostics & repair',
    accentClass: 'accentDiagnostics',
    items: [
      { label: 'Engine Diagnostics', iconName: 'Search' },
      { label: 'Transmission Service', iconName: 'Cog' },
      { label: 'Brake Service', iconName: 'ShieldCheck' },
      { label: 'Electrical & Battery', iconName: 'Zap' }
    ]
  },
  {
    title: 'Comfort & safety',
    accentClass: 'accentComfort',
    items: [
      { label: 'A/C & Heating', iconName: 'Thermometer' },
      { label: 'Recall Service', iconName: 'BellMinus' },
      { label: 'Pre-Trip Inspection', iconName: 'ClipboardCheck' },
      { label: 'Fluid Flushes', iconName: 'Droplet' }
    ]
  }
];

export default serviceCapabilityGroups;
